import { render } from "./EmployeeTimeReport.vue?vue&type=template&id=5f182783&scoped=true"
import script from "./EmployeeTimeReport.vue?vue&type=script&lang=js"
export * from "./EmployeeTimeReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=5f182783&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f182783"]])

export default __exports__